/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

import api from './api';

export const getLocalization = async (key) => {
    return api.get('getLocalization', { key });
};

export const editLocalization = async (key, locales) => {
    return api.patch('editLocalization', { localeKey: key, locales });
};

export const localizationModeExit = async () => {
    return api.post('localizationModeExit');
};
